import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../Button";
export const ReloadAction = () => {
    const { t } = useTranslation("errorPages");
    const handleButtonClick = () => {
        window.location.reload();
    };
    return (React.createElement(Button, { variant: "outlined", color: "primary", onClick: handleButtonClick, sx: { mt: 3 } }, t("502.button")));
};
export const LoginAction = () => {
    const { t } = useTranslation("errorPages");
    const handleButtonClick = () => {
        // TODO: change to logout when it will not auto-re-login with same credentials
        // Removal of expiry dates will force useAuth to do re-login
        window.localStorage.removeItem("access_token_exp");
        window.localStorage.removeItem("refresh_token_exp");
        window.location.reload();
    };
    return (React.createElement(Button, { variant: "outlined", color: "primary", onClick: handleButtonClick, sx: { mt: 3 } }, t("403.button")));
};
export const BackAction = () => {
    const { t } = useTranslation("errorPages");
    const hasBackPage = history.length > 1;
    const handleButtonClick = () => {
        if (hasBackPage) {
            history.back();
        }
    };
    if (!hasBackPage) {
        return null;
    }
    return (React.createElement(Button, { variant: "outlined", color: "primary", onClick: handleButtonClick, sx: { mt: 3 } }, t("404.button")));
};
//# sourceMappingURL=ButtonActions.js.map